import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'TryInStoreButton.title',
    description: 'TryInStoreButton title',
    defaultMessage: 'Try in Store',
  },
});
